module.exports = __webpack_public_path__ + "static/media/1021122.2e87a091.png";